module.exports = __webpack_public_path__ + "assets/img/cpys3_1.827db6b8.jpg";